var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6094 13.8789H2.39062C2.09678 13.8789 1.85938 14.1163 1.85938 14.4102V15.0078C1.85938 15.0809 1.91914 15.1406 1.99219 15.1406H15.0078C15.0809 15.1406 15.1406 15.0809 15.1406 15.0078V14.4102C15.1406 14.1163 14.9032 13.8789 14.6094 13.8789ZM4.27822 12.4844C4.31143 12.4844 4.34463 12.4811 4.37783 12.4761L7.17021 11.9863C7.20342 11.9797 7.23496 11.9647 7.2582 11.9398L14.2956 4.90244C14.311 4.88708 14.3232 4.86884 14.3315 4.84876C14.3399 4.82867 14.3442 4.80714 14.3442 4.7854C14.3442 4.76366 14.3399 4.74213 14.3315 4.72204C14.3232 4.70196 14.311 4.68372 14.2956 4.66836L11.5364 1.90752C11.5049 1.87598 11.4634 1.85938 11.4186 1.85938C11.3737 1.85938 11.3322 1.87598 11.3007 1.90752L4.26328 8.94492C4.23838 8.96982 4.22344 8.99971 4.2168 9.03291L3.72705 11.8253C3.7109 11.9142 3.71667 12.0058 3.74386 12.092C3.77105 12.1782 3.81885 12.2564 3.88311 12.32C3.99268 12.4263 4.13047 12.4844 4.27822 12.4844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.014c60cf3384234f56d2e33479836c69.svg";
export { ForwardRef as ReactComponent };